export default function WhatsappIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.5 23C18.299 23 23 18.299 23 12.5C23 6.70101 18.299 2 12.5 2C6.70101 2 2 6.70101 2 12.5C2 14.3832 2.49575 16.1505 3.36386 17.6787L2 23L7.48615 21.7278C8.97603 22.5391 10.6842 23 12.5 23ZM12.5 21.3846C17.4068 21.3846 21.3846 17.4068 21.3846 12.5C21.3846 7.59316 17.4068 3.61538 12.5 3.61538C7.59316 3.61538 3.61538 7.59316 3.61538 12.5C3.61538 14.3945 4.20838 16.1506 5.21888 17.5927L4.42308 20.5769L7.45995 19.8177C8.89202 20.8059 10.6284 21.3846 12.5 21.3846Z"
        fill="white"
      />
      <path
        d="M9.87502 7.62504C9.62537 7.1236 9.2424 7.168 8.85551 7.168C8.16407 7.168 7.08594 7.99621 7.08594 9.53759C7.08594 10.8008 7.64259 12.1836 9.51831 14.2522C11.3285 16.2485 13.707 17.2812 15.6817 17.2461C17.6563 17.2109 18.0625 15.5117 18.0625 14.9379C18.0625 14.6835 17.9047 14.5566 17.796 14.5221C17.1231 14.1992 15.882 13.5975 15.5996 13.4844C15.3172 13.3714 15.1698 13.5243 15.0781 13.6075C14.8221 13.8515 14.3144 14.5707 14.1406 14.7325C13.9668 14.8942 13.7077 14.8124 13.5999 14.7512C13.2031 14.592 12.1272 14.1134 11.2696 13.2821C10.209 12.254 10.1467 11.9002 9.94693 11.5854C9.78707 11.3335 9.90437 11.1789 9.96291 11.1114C10.1914 10.8477 10.507 10.4406 10.6485 10.2383C10.79 10.036 10.6776 9.72889 10.6102 9.53759C10.3203 8.71488 10.0747 8.02618 9.87502 7.62504Z"
        fill="white"
      />
    </svg>
  );
}
